import { TvProgramType } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { IntlShape } from 'react-intl';

const getTvProgramTypeNameMap = (intl: IntlShape) => ({
    MOVIE: intl.formatMessage({
        id: 'features.channel.aed34b9f60ee115dfa7918b742336277',
        defaultMessage: 'movie',
        description: 'Название фильма в типах контента',
    }),
    SERIES: intl.formatMessage({
        id: 'features.channel.8158f53b1911383cf67518088bb0d051',
        defaultMessage: 'TV series',
        description: 'Название сериала в типах контента',
    }),
    SHOW: intl.formatMessage({
        id: 'features.channel.a7dd12b1dab17d25467b0b0a4c8d4a92',
        defaultMessage: 'show',
        description: 'Название шоу в типах контента',
    }),
    SPORT: intl.formatMessage({
        id: 'features.channel.088495f30901580ddd5171531cd26649',
        defaultMessage: 'sports',
        description: 'Название спорта в типах контента',
    }),
});

export const transformTvProgramTypeNameMap = (
    intl: IntlShape,
    typeName: TvProgramType | null | undefined
): string | undefined => (typeName && getTvProgramTypeNameMap(intl)[typeName]) || undefined;
